import React from 'react';
import CommonOperationScreen from '../../components/CommonOperationScreen/CommonOperationScreen';

const Waha = () => {
	return <CommonOperationScreen operationName="WAHA" buttonLabel="Mark WAHA Complete" />;
};

export default Waha;
